import { Divider, Input, Select } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;

interface ContentWrapperProps {
  $isDesktop: boolean;
}

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: grid;
  row-gap: 20px;
  column-gap: 24px;
  width: 100%;
  margin: 0 auto;
  ${({ $isDesktop }) => ($isDesktop ? 'grid-template-columns: repeat(2, 1fr);' : 'grid-template-columns: 1fr;')}

  .ant-form-item {
    width: 100%;
    height: auto;
  }
  .ant-form-item-row {
    display: flex;
    flex-flow: column;
  }
`;
